import React from 'react'

export const LinkOut = props => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d="M21.1113 2H13.1117C12.6208 2 12.2229 2.39795 12.2229 2.88885C12.2229 3.37974 12.6208 3.77769 13.1117 3.77769L18.9655 3.77769L10.2611 12.482C9.914 12.8292 9.914 13.3919 10.2611 13.7391C10.6082 14.0862 11.171 14.0862 11.5181 13.7391L20.2225 5.0347L20.2225 10.8884C20.2225 11.3793 20.6204 11.7773 21.1113 11.7773C21.6022 11.7773 22.0002 11.3793 22.0002 10.8884L22.0002 2.88884C22.0002 2.39795 21.6022 2 21.1113 2ZM5.55538 4.22229H10.8884V5.99998H5.55538C4.57359 5.99998 3.77769 6.79588 3.77769 7.77767V18.4438C3.77769 19.4256 4.57359 20.2215 5.55538 20.2215H16.2215C17.2033 20.2215 17.9992 19.4256 17.9992 18.4438V13.1107H19.7769V18.4438C19.7769 20.4074 18.1851 21.9992 16.2215 21.9992H5.55538C3.5918 21.9992 2 20.4074 2 18.4438V7.77767C2 5.81409 3.5918 4.22229 5.55538 4.22229Z"
    />
  </svg>
)